exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "datatable-footer {\r\n    display: -webkit-box;\r\n    height: 125px;\r\n    margin-top: 15px;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./ClientApp/app/components/benefits/benefits.component.css
// module id = 544
// module chunks = 0